export default "__VITE_ASSET__CobfP0jM__"